<template>
  <section>
    <section class="container-wfs-destaque">
      <div class="container-fuild wfs-destaque-img">
        <div class="container wfs-home-destaque">
          <h1
            class="destaque-home-title"
            style="
              opacity: 1;
              transform: translateX(0px) translateY(0px) translateZ(0px);
              display: block;
              transition: opacity 500ms ease 0s, transform 500ms ease 0s;
            "
          >
            OUVIDORIA
          </h1>
          <h2 class="destaque-home-subtitle not--mobile" >
            Bem-vindo a Ouvidoria Geral da Prefeitura de São José de Ubá! Aqui
            você pode nos ajudar a manter nossos serviços em excelência.
          </h2>

          <h2 class="destaque-home-subtitle mobile" >
            Bem-vindo a Ouvidoria da Prefeitura de São José de Ubá! <br>
            <!--<router-link to="/home">Clique aqui para baixar nosso Aplicativo</router-link> <br>
            ou-->
          </h2>

          <h3 class="wfs-text-opcao">
            Escolha abaixo como deseja se manifestar!
          </h3>

          <div class="container" style="min-height: 133px;">
            <div class="row" style="display: contents">
              <!-- opcoes de manifestacao -->
              <listManif  :titulo=a.nome :op=a.id  v-for="a in tiposAssunto" :key="a.id" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="wfs-section-two container-fuild">
      <div class="container --section-two">
        <h2 class="section-two-title">
          Veja também outros
          <strong class="section-two-bold">serviços</strong> que estão
          disponíveis no portal da prefeitura
        </h2>
        <p class="section-two-description">
          Clique nos ícones abaixo e conheça outros serviços online da
          Prefeitura de São José de Ubá. Através deles você pode
          estreitar sua participação junto ao governo local.
        </p>
        <div class="row">
          <!--servicos externos OBS.: não está vindo da api existe la embaixo uma Constante Array contendo os conteudos informados. -->
          <servicos :link='s.link' :img='s.img' :titulo='s.titulo' :texto='s.texto' v-for="s in Servicos" :key="s.titulo"/>
        </div>
      </div>
    </section>
    <section class="wfs-section-transp container-fuild">
      <div class="container">
        <div>
          <h2 class="texto-comprometimento">Estamos comprometidos em fazer um governo <strong class="wfs--transp-bold-text">TRANSPARENTE.</strong></h2>
          <p class="wfs--trans-parag">Estamos atuando de forma proativa na disponibilização dos dados e informações da Prefeitura viabilizando a participação da sociedade nas diversas etapas dos serviços públicos.</p>
        </div>
      </div>  
    </section>
    
  </section>
</template>



<script>
import "src/controller/site/homeController.js";
import StatsCard from "src/components/Cards/StatsCard.vue";
import StatsCard2 from "src/components/Cards/StatsCard2.vue";
import StatsCard3 from "src/components/Cards/StatsCard3.vue";
import StatsCard4 from "src/components/Cards/StatsCard4.vue";

import ListManif from 'src/components/Home/homeListaManif.vue'
import Servicos from 'src/components/Home/listaServicos.vue'

const servicos = [
  {
    link:'#',
    img: 'Icon-monitor.png', 
    titulo:'e-SIC',
    texto:'e-SIC é o nosso sistema de informações ao cidadão,a plataforma que permite ao cidadão de São José de Ubá fazer pedidos de informações públicas.',
  },
  {
    link:'#',
    img: 'Icon-list-white.png', 
    titulo:'Legislação',
    texto:'Consulte e pesquise informações sobre a legislção municipal do nosso município de forma rápida e fácil.',
  },
  {
    link:'#',
    img: 'Icon-responsive-white.png', 
    titulo:'Licitações',
    texto:'Acompanhe as licitações municipais através do nosso módulo de licitações.',
  },
  {
    link:'#',
    img: 'Icon-reuse.png', 
    titulo:'Concursos Públicos',
    texto:'Aqui você pode acompanhar as publicações e convocações relacionadas aos concursos públicos e processos seletivos.',
  },
  {
    link:'#',
    img: 'Icon-browser-white.png', 
    titulo:'Portal da Transparência',
    texto:'Nosso portal da transparência tem todas as informações necessárias sobre os gastos e investimentos do governo municipal.',
  },
  {
    link:'#',
    img: 'Icon-heart.png', 
    titulo:'Projetos e Convênios',
    texto:'Acompanhe os investimentos em projetos e convênios da prefeitura de São José de Ubá.',
  },
];


export default {
  name: "home",
  metaInfo: {
    htmlAttrs: {
      lang: "pt-BR",
    },
    title: "Pagina Inicial",
    meta: [
      {
        name: "descrition",
        content:
          "Ouvidoria da Prefeitura Municipal de São José de Ubá.",
      },
      { property: "og:title", content: "Pagina Inicial" },
      { property: "og:image", content: "/img/logo-topo.png" },
    ],
  },
  props: {
    id: {},
  },
  components: {
    StatsCard,
    StatsCard2,
    StatsCard3,
    StatsCard4,
    ListManif,
    Servicos
  },
  data() {
    return {
      manifestacao: null,
      recebido: {
        assunto: null,
        conteudo: null,
        secretaria: null,
        tipo_assunto: null,
        abertura: null,
      },
      tiposAssunto:[],
      ativo_recebido: 0,
      vazio: 0,
      Servicos: servicos,
    };
  },
  methods: {
    CadastrarManifesto() {
      this.$router.push({ name: "realizarManifestacao" });
    },
    zerarRecebido() {
      this.manifestacao = null;
      this.ativo_recebido = 0;
    },
    async listarTAssunto(){
      try {
        let data = await this.$listarTiposAssunto();
        this.tiposAssunto = data.data;
      } catch (e) {}
    },
    async buscarManifestacao() {
      try {
        let data = await this.$buscarManifesto(this.manifestacao);
        console.log(data.data);
        if (data.data == "") {
          this.vazio = 1;
        } else {
          this.vazio = 0;
          //this.filtroAssunto(data.data[0].assunto);
          this.recebido.assunto = data.data[0].assunto;
          this.recebido.conteudo = data.data[0].conteudo;
          this.filtroSecretaria(data.data[0].secretaria);
          this.recebido.tipo_assunto = data.data[0].tipo_assunto;
          this.recebido.abertura = data.data[0].abertura;
          this.ativo_recebido = 1;
        }
      } catch (error) {}
    },
    async filtroAssunto(id_assunto) {
      try {
        let data = await this.$assuntos();
        let dados = data.data;
        dados.forEach((element) => {
          if (id_assunto == element.id) {
            this.recebido.assunto = element.assunto;
          }
        });
        //this.assuntos = data.data;
      } catch (error) {}
    },
    async filtroSecretaria(id_secretaria) {
      try {
        let data = await this.$secretaria();
        let dados = data.data;
        dados.forEach((element) => {
          if (id_secretaria == element.id) {
            this.recebido.secretaria = element.secretaria;
          }
        });
      } catch (error) {}
    },
  },
  beforeMount() {
    this.listarTAssunto();
  },
};
</script>

<style scoped>
.msg-manifesto {
  background-color: #eaeaea;
  border-radius: 6px;
}
.msg-manifeso,
.color1 {
  color: #c50f0f;
}
.msg-manifeso,
.color2 {
  color: #0fc546;
}
.msg-manifeso,
.color3 {
  color: #c5850f;
}
.msg-manifeso,
.color4 {
  color: #0f92c5;
}
.card-site {
  background-color: #e3e3e3;
}
.icon-home {
  margin-top: 15px;
}
.card-txt-h {
  text-align: center;
  padding-top: 10px;
  font-size: 18px;
  color: #828282;
  font-weight: 700;
}
</style>
